"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AlertWatchHandler = void 0;
const lib_palette_1 = __importDefault(require("@opsbase/lib-palette"));
const useCallforward_1 = __importDefault(require("@opsbase/react-hooks/useCallforward"));
const web_css_1 = __importDefault(require("@opsbase/web-css"));
const BellIcon_1 = __importDefault(require("@opsbase/web-icons/icons/BellIcon"));
const CloseDialogIcon_1 = __importDefault(require("@opsbase/web-icons/icons/CloseDialogIcon"));
const Horizontal_1 = __importDefault(require("@opsbase/web-layout/Horizontal"));
const Pane_1 = __importDefault(require("@opsbase/web-layout/Pane"));
const Vertical_1 = __importDefault(require("@opsbase/web-layout/Vertical"));
const Badge_1 = __importDefault(require("@opsbase/web-ui/Badge"));
const Button_1 = __importDefault(require("@opsbase/web-ui/Button"));
const IconButton_1 = __importDefault(require("@opsbase/web-ui/IconButton"));
const react_1 = __importStar(require("react"));
const AlertCard_1 = __importDefault(require("../AlertCard/AlertCard"));
const useAlertWatcher_1 = __importDefault(require("../AlertWatcherController/useAlertWatcher"));
const useAlertWatcherActions_1 = __importDefault(require("../AlertWatcherController/useAlertWatcherActions"));
const lib_i18n_1 = __importDefault(require("@opsbase/lib-i18n"));
const makeMyClasses = () => ({
    listPane: {
        position: 'fixed',
        right: 0,
        top: 50,
        bottom: 0,
        zIndex: 300,
        width: 320,
        backgroundColor: lib_palette_1.default.White.main,
        borderLeft: `1px solid ${lib_palette_1.default.LineGrey.main}`,
    },
    listButtons: {
        height: 44,
        borderBottom: `1px solid ${lib_palette_1.default.LineGrey.main}`,
    },
});
function AlertWatchHandler() {
    var _a;
    const { alerts, readIds } = (0, useAlertWatcher_1.default)();
    const { markAllAsRead, markAsRead, markAsUnread } = (0, useAlertWatcherActions_1.default)();
    const [open, setOpen] = (0, react_1.useState)(false);
    const noOfUnread = ((_a = alerts.filter(a => readIds.indexOf(a.id) < 0)) === null || _a === void 0 ? void 0 : _a.length) || 0;
    const myCss = (0, web_css_1.default)(makeMyClasses);
    const handleToggleListPane = (0, react_1.useCallback)(() => setOpen(!open), [setOpen, open]);
    const handleMarkRead = (0, useCallforward_1.default)(id => () => markAsRead(id), [markAsRead]);
    const handleMarkUnread = (0, useCallforward_1.default)(id => () => markAsUnread(id), [markAsUnread]);
    const handleMarkAllRead = (0, react_1.useCallback)(() => markAllAsRead(), [markAllAsRead]);
    return (0, react_1.useMemo)(() => {
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(Badge_1.default, { value: noOfUnread },
                react_1.default.createElement(IconButton_1.default, { size: 32, round: true, icon: react_1.default.createElement(BellIcon_1.default, { color: lib_palette_1.default.GreyBlue, size: 32 }), onClick: handleToggleListPane })),
            open && (react_1.default.createElement(Vertical_1.default, { shrink: true, gutter: true, classes: { root: myCss.listPane } },
                react_1.default.createElement(Horizontal_1.default, { padding: true, shrink: true, classes: { root: myCss.listButtons } },
                    react_1.default.createElement(IconButton_1.default, { icon: react_1.default.createElement(CloseDialogIcon_1.default, null), onClick: handleToggleListPane }),
                    react_1.default.createElement(Pane_1.default, null, !!noOfUnread && (react_1.default.createElement(Button_1.default, { small: true, color: lib_palette_1.default.secondary, background: 'transparent', label: lib_i18n_1.default.t('mark-all-read'), onClick: handleMarkAllRead })))),
                react_1.default.createElement(Vertical_1.default, { scrollY: true }, alerts.map(alert => (react_1.default.createElement(AlertCard_1.default, { key: alert.id, alert: alert, read: readIds.indexOf(alert.id) >= 0, onMarkAsRead: handleMarkRead(alert.id), onMarkAsUnread: handleMarkUnread(alert.id) }))))))));
    }, [
        noOfUnread,
        handleToggleListPane,
        open,
        myCss,
        handleMarkAllRead,
        alerts,
        readIds,
        handleMarkRead,
        handleMarkUnread,
    ]);
}
exports.AlertWatchHandler = AlertWatchHandler;
exports.default = AlertWatchHandler;
